import { useTranslations } from "use-intl";

const ITEM_TYPES = ["payable", "receivable", "expense", "receipt", "unsupported", "tax_account_transaction", "own_account_transfer"] as const;
const REVIEW_TYPES = ["choice", "context", "approve", "manual_entry"] as const;
const STATUSES = ["needs_review", "pending", "completed"] as const;

function includes<T extends string>(list: readonly T[], value: string): value is T {
  return (list as readonly string[]).includes(value);
}

/** Words for a review item's type, review type and status; a value the catalog does not know shows as it is. */
export function useReviewLabels() {
  const t = useTranslations("consultantReview.table");
  return {
    itemType: (type: string) => (includes(ITEM_TYPES, type) ? t(`itemTypes.${type}`) : type),
    reviewType: (type: string) => (includes(REVIEW_TYPES, type) ? t(`reviewTypes.${type}`) : type),
    status: (status: string) => (includes(STATUSES, status) ? t(`statuses.${status}`) : status),
  };
}
